<nav aria-label="Stepper" class="tablist-label">
  <ol
    class="nav"
    [class.nav-tabs]="!showSteps"
    [class.nav-steps]="showSteps"
    [attr.aria-label]="ariaLabel ? ariaLabel : null"
    [attr.aria-labelledby]="ariaLabelledBy ? ariaLabelledBy : null"
  >
    <li
      class="nav-item"
      [class.active]="i === tabIndex"
      [class.disabled]="tab.disabled"
      *ngFor="let tab of tabs; let i = index"
      (click)="tabClicked(i)"
    >
      <a
        *ngIf="!tab.disabled"
        class="nav-link"
        href=""
        #tabElements
        (click)="linkClickHandler($event)"
        [id]="getElementId('tab', i)"
        [attr.aria-controls]="getElementId('content', tabIndex)"
        [attr.aria-current]="i === tabIndex ? 'step' : null"
        [attr.tabIndex]="i === tabIndex ? 0 : -1"
        [attr.index]="i"
      >
        <span class="step-number" *ngIf="showSteps">{{ i + 1 }}</span>
        <span [class.step-label]="showSteps">{{ tab.name }}</span>
      </a>
      <a
        *ngIf="tab.disabled"
        class="nav-link"
        #tabElements
        href="#"
        [attr.aria-disabled]="true"
        [id]="getElementId('tab', i)"
        [attr.aria-controls]="getElementId('content', tabIndex)"
        [attr.aria-current]="i === tabIndex ? 'step' : null"
        [attr.tabIndex]="-1"
        [attr.index]="i"
      >
        <span class="step-number" *ngIf="showSteps">{{ i + 1 }}</span>
        <span [class.step-label]="showSteps">{{ tab.name }}</span>
      </a>
    </li>
    <!--active stuff-->
  </ol>
  <div [id]="getElementId('content', tabIndex)">
    <ng-container *ngTemplateOutlet="getActiveTabTemplate()"></ng-container>
  </div>
</nav>
